// extracted by mini-css-extract-plugin
export var $animation_name = "Contact-module--$animation_name--792d0";
export var FormPanel = "Contact-module--FormPanel--5c150";
export var FormPanelInner = "Contact-module--FormPanelInner--29c58";
export var FormPanelInner___sending = "Contact-module--FormPanelInner___sending--056f3";
export var FormPanelInner___sent = "Contact-module--FormPanelInner___sent--7cf9d";
export var FormPanelInner__row = "Contact-module--FormPanelInner__row--f031b";
export var FromPanelconfirmation = "Contact-module--FromPanelconfirmation--a127a";
export var FromPanelconfirmation___sent = "Contact-module--FromPanelconfirmation___sent--90e0b";
export var Inner = "Contact-module--Inner--4ea42";
export var TextPanel = "Contact-module--TextPanel--5c3f5";
export var TextPanel__blurb = "Contact-module--TextPanel__blurb--f74d9";
export var TextPanel__title = "Contact-module--TextPanel__title--d6fe9";
export var Wrapper = "Contact-module--Wrapper--265ba";